import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const query = graphql`
  query PortfolioImageQuery {
    images: allFile(
      filter: { sourceInstanceName: { eq: "images" }, extension: { regex: "/jpg|jpeg|png/" } }
    ) {
      edges {
        node {
          relativePath
          childImageSharp {
            fluid(maxWidth: 1400, quality: 85) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

const PortfolioImage = ({ src, alt, className, loading }) => (
  <StaticQuery
    query={query}
    render={(data) => {
      // src comes in as e.g. "/dj/dj-01.jpg" — strip leading slash to match relativePath
      const relativePath = src.replace(/^\//, '');
      const match = data.images.edges.find(({ node }) => node.relativePath === relativePath);

      if (!match) {
        // Fallback to plain img if not found in GraphQL (shouldn't happen in prod)
        return (
          <img
            className={className}
            src={src}
            alt={alt || ''}
            loading={loading || 'lazy'}
            decoding="async"
          />
        );
      }

      return (
        <Img
          className={className}
          fluid={match.node.childImageSharp.fluid}
          alt={alt || ''}
          loading={loading || 'lazy'}
          fadeIn={loading !== 'eager'}
        />
      );
    }}
  />
);

PortfolioImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.string,
};

PortfolioImage.defaultProps = {
  alt: '',
  className: '',
  loading: 'lazy',
};

export default PortfolioImage;
